import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import api from './api'
import getters from './getters'
import codes from './codes'
import refRegister from './ref-register'
import payments from './payments'
import paymentLogs from './payment-logs'
import referrals from './referrals'
import business from './business'
import card from './cards'
import balanceHistory from './balance-history'
import createAccount from './create-account'
import businessRegister from './business-register'
import leader from './leader'
import systemNotifications from './system-notifications'
import accountBalanceHistory from './account-balance-history'
import dashboard from './dashboard'
import socials from './socials'
import data from './data'
import news from './news'
import notification from './notification'
import payout from './payout'
import report from './report'
import payoutLog from './payoutLog'
import admin from './admin'
import roles from './roles'
import systemLogs from './system-logs'
import clientRefillHistory from './client-refill-history'
import clientNewsView from './client-news-view'
import sqlReports from './sqlReports'
import groups from './groups'
import cashback from './cashback'
import unallocatedClients from './unallocated-clients'
import moderation from './moderation'
import clientNews from './client-news'
import customers from './customers'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app,
        api,
        data,
        codes,
        payments,
        paymentLogs,
        referrals,
        business,
        card,
        customers,
        balanceHistory,
        notification,
        refRegister,
        businessRegister,
        createAccount,
        dashboard,
        accountBalanceHistory,
        socials,
        leader,
        news,
        payout,
        report,
        payoutLog,
        admin,
        systemNotifications,
        clientNewsView,
        roles,
        systemLogs,
        clientRefillHistory,
        sqlReports,
        groups,
        cashback,
        unallocatedClients,
        moderation,
        clientNews
    },
    getters
})

export default store

const initialStateCopy = JSON.parse(JSON.stringify(store.state))

export function resetState() {
    store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)))
}
